module.exports = __webpack_public_path__ + "img/sobre_territorio_matachaves_02.6df51020.png";